import { render, staticRenderFns } from "./ProductSelectCard.vue?vue&type=template&id=1b818ca0&scoped=true"
import script from "./ProductSelectCard.vue?vue&type=script&lang=js"
export * from "./ProductSelectCard.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectCard.vue?vue&type=style&index=0&id=1b818ca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b818ca0",
  null
  
)

export default component.exports